const pdfjs = require('pdfjs-dist/build/pdf');

if (process.env.NODE_ENV !== 'test') {
  pdfjs.GlobalWorkerOptions
    .workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
}

export default pdfjs;
